import React from "react";
import MultiSelectRefinementList from "components/search/base/MultiSelectRefinementList";
import { authorGenders } from "components/search/references/authorCategories";

const AuthorGenderMultiSelect = () => {
  return (
    <MultiSelectRefinementList
      attribute="authorGender"
      categories={authorGenders}
      className="refinement-list__author-gender"
      id="refinement-list__author-gender"
      limit={100}
      name="refinement-list__author-gender"
      title="Gender"
    />
  );
};

export default AuthorGenderMultiSelect;
